import { Flow_0_0_2, getFullItemOne } from '@flexus/core';
import { map } from 'rxjs/operators';

export const BET_SP_DETAILS: Flow_0_0_2 = {
	id: 'SPDetails',
	itemType: 'flow',
	name: 'SP Details',
	excludeForOnlyStates: [169, 20],
	header: {
		title: (store, bf) => {
			return store.select(getFullItemOne).pipe(
				map(itemOne => {
					if (itemOne) {
						return `SP Details : ${itemOne?.loan_information?.mavenclaimnumber} - ${itemOne?.applicant?.surname}`;
					} else {
						return 'SP Details';
					}
				})
			);
		},
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	startNode: 'SPDetails',
	instructions: {
		editRoles: {
			0: ''
		},
		viewRoles: {
			0: ''
		}
	},
	actionPanel: instance => {
		return () => {
			return [{}];
		};
	},
	nodes: {
		SPDetails: {
			component: 'FLXSPDetailsJobContextComponent',
			navs: [],
			inputs: {
				title: 'SP Details'
			}
		}
	}
};
